import { useState } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useStore } from '@/store';
import { selectArmsSorted } from '@/store/selectors';
import { CollapsibleSection } from '@/components/ui/CollapsibleSection';
import { DataEntryTable } from './DataEntryTable';

/** Collapsible section 2 — Data Entry (P1.5.5). Shows per-arm tabs. */
export function DataEntrySection() {
  const arms = useStore(useShallow(selectArmsSorted));
  const [activeArm, setActiveArm] = useState(0);
  const arm = arms[activeArm] ?? arms[0];

  return (
    <CollapsibleSection sectionKey="calculator.dataEntry" title="Data Entry" column="left">
      <div role="tablist" aria-label="Arm data entry" className="flex-row-gap-1 mb-3">
        {arms.map((a, i) => (
          <button
            key={a.id}
            type="button"
            role="tab"
            aria-selected={activeArm === i}
            className={`btn btn-sm ${activeArm === i ? 'btn-primary' : 'btn-secondary'}`}
            onClick={() => setActiveArm(i)}
          >
            {a.label}
          </button>
        ))}
      </div>
      {arm ? <DataEntryTable arm={arm} /> : <p className="empty-state">No arms configured.</p>}
    </CollapsibleSection>
  );
}
